<app-dev-mode />
<div class="top-nav flex__justify-between flex__align-center padding-vertical--0 padding-horizontal--half">
  <div class="top-nav__left-section flex__align-center padding-vertical--0 padding-horizontal--half">
    <span class="top-nav__logo" (click)="reloadWebsite()"></span>
    <h5 class="top-nav__title">Information Exchange</h5>
    @if (showProjectSelector()) {
      <app-project-selector
        [projects]="projects()"
        [selectedProject]="currentProject()"
        (selected)="onSelectedProject($event)"
      />
    }
    @if (pageTitle()) {
      <div class="page-title-trigger">
        @if (hasPageTitleDropdown()) {
          <button
            type="button"
            mat-button
            class="page-title--interactive"
            [matMenuTriggerFor]="pageTitleMenu"
          >
            {{ pageTitleText() }}

            @if (pageTitle()?.deliverableTitle) {
              <span class="page-title__deliverable-title">
                {{ pageTitle()?.deliverableTitle }}
              </span>
            }
            <div>
              <mat-icon fontIcon="arrow_drop_down" />
            </div>
          </button>

          @if (showInlinePageTitleTabs() && pageTitle()?.items?.length) {
            <mat-tab-group
              [selectedIndex]="pageTitle()?.selectedIndex ?? 0"
              (selectedIndexChange)="pageTitle()?.onTabChange?.($event)"
              class="page-title-inline-tabs"
              aria-label="Subscription Matrix view"
            >
              @for (item of pageTitle()?.items; track item.value) {
                <mat-tab [label]="item.label"></mat-tab>
              }
            </mat-tab-group>
          }
        } @else {
          <span
            class="page-title--non-interactive"
            [matTooltip]="pageTitle()?.tooltipText || ''"
            matTooltipClass="page-title-tooltip"
            [matTooltipDisabled]="!pageTitle()?.tooltipText"
          >
            {{ pageTitleText() }}

            @if (pageTitle()?.deliverableTitle) {
              <span class="page-title__deliverable-title">
                {{ pageTitle()?.deliverableTitle }}
              </span>
            }
          </span>
          @if (showViewModeToggle()) {
            <button
              type="button"
              mat-icon-button
              disableRipple
              class="worksheet-view-toggle-trigger"
              [matMenuTriggerFor]="viewModeMenu"
              aria-label="Select worksheet view"
              data-test-id="worksheet-view-mode-trigger"
            >
              <mat-icon size="small" fontIcon="arrow_drop_down" />
            </button>
            <mat-menu #viewModeMenu="matMenu">
              <button
                mat-menu-item
                type="button"
                class="worksheet-view-toggle__option"
                data-test-id="worksheet-grid-view-option"
                (click)="onViewModeChange('grid')"
              >
                @if (viewMode() === 'grid') {
                  <mat-icon svgIcon="checkmark" />
                }
                <span>Grid</span>
              </button>
              <button
                mat-menu-item
                type="button"
                class="worksheet-view-toggle__option"
                data-test-id="worksheet-list-view-option"
                (click)="onViewModeChange('list')"
              >
                @if (viewMode() === 'list') {
                  <mat-icon svgIcon="checkmark" />
                }
                <span>List</span>
              </button>
            </mat-menu>
            <div class="worksheet-view-toggle" role="group" aria-label="Worksheet view mode">
              <button
                type="button"
                class="worksheet-view-toggle__button"
                [class.worksheet-view-toggle__button--active]="viewMode() === 'grid'"
                [attr.aria-pressed]="viewMode() === 'grid'"
                data-test-id="worksheet-grid-view-button"
                aria-label="Grid view"
                (click)="onViewModeChange('grid')"
              >
                Grid
              </button>
              <button
                type="button"
                class="worksheet-view-toggle__button"
                [class.worksheet-view-toggle__button--active]="viewMode() === 'list'"
                [attr.aria-pressed]="viewMode() === 'list'"
                data-test-id="worksheet-list-view-button"
                aria-label="List view"
                (click)="onViewModeChange('list')"
              >
                List
              </button>
            </div>
          }
        }
      </div>
    }

    <mat-menu #pageTitleMenu="matMenu" class="page-title-overlay" panelClass="page-title-tabs-menu">
      @if (pageTitle()?.items?.length) {
        <mat-tab-group
          [selectedIndex]="pageTitle()?.selectedIndex ?? 0"
          (selectedIndexChange)="pageTitle()?.onTabChange?.($event)"
          class="page-title-tabs"
        >
          @for (item of pageTitle()?.items; track item.value) {
            <mat-tab [label]="item.label"></mat-tab>
          }
        </mat-tab-group>
      }
    </mat-menu>
  </div>

  <div class="top-nav__right-section flex__align-center padding-vertical--0 padding-horizontal--half">
    <app-deliverable-search (select)="onDeliverableSelect($event)" />
    <app-help-centre />
    <app-notification-menu />

    <app-avatar
      color="orange"
      size="s"
      [dsPopover]="content"
      dsPopoverMaxWidth="376px"
      data-test-id="top-nav-avatar"
    />
  </div>
</div>

<ng-template #content>
  <app-avatar-popover />
</ng-template>
